export default __webpack_public_path__ + "static/media/icon-share-via-facebook.e548a7b2.svg";